/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_TitleInputs */

const en_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | A Better Way To Swing | Des Moines, Iowa`)
};

const es_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Una mejor forma de hacer swing | Des Moines, Iowa`)
};

const de_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Eine bessere Art zu schwingen | Des Moines, Iowa`)
};

const zh_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 更好的挥杆方式 | 爱荷华州得梅因`)
};

const ar_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | طريقة أفضل للسوينغ | Des Moines, Iowa`)
};

const fr_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Une meilleure façon de swinguer | Des Moines, Iowa`)
};

const vi_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Một cách swing tốt hơn | Des Moines, Iowa`)
};

const sw_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Njia Bora ya Kupiga Swing | Des Moines, Iowa`)
};

const th_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | วิธีที่ดีกว่าในการสวิง | ดิมอยน์ ไอโอวา`)
};

const bs_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Bolji način zamaha | Des Moines, Iowa`)
};

const ja_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | より良いスイングへの道 | Des Moines, Iowa`)
};

const ko_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 더 나은 스윙 방법 | Des Moines, Iowa`)
};

const pt_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Um jeito melhor de fazer o swing | Des Moines, Iowa`)
};

const it_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Un modo migliore di fare swing | Des Moines, Iowa`)
};

const sv_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Ett bättre sätt att svinga | Des Moines, Iowa`)
};

const nl_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Een betere manier om te swingen | Des Moines, Iowa`)
};

const da_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | En bedre måde at svinge på | Des Moines, Iowa`)
};

const nb_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | En bedre måte å svinge på | Des Moines, Iowa`)
};

const fi_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Parempi tapa swingata | Des Moines, Iowa`)
};

const pl_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Lepszy sposób na swing | Des Moines, Iowa`)
};

const ru_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Лучший способ делать свинг | Des Moines, Iowa`)
};

const tr_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Sving İçin Daha İyi Bir Yol | Des Moines, Iowa`)
};

const hi_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | स्विंग का बेहतर तरीका | Des Moines, Iowa`)
};

const id_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Cara Lebih Baik Melakukan Ayunan | Des Moines, Iowa`)
};

const ms_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Cara Lebih Baik untuk Hayunan | Des Moines, Iowa`)
};

const cs_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Lepší způsob golfového švihu | Des Moines, Iowa`)
};

const el_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Ένας καλύτερος τρόπος για σβινγκ | Des Moines, Iowa`)
};

const he_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | דרך טובה יותר לסווינג | Des Moines, Iowa`)
};

const af_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 'n Beter manier om te swaai | Des Moines, Iowa`)
};

const hu_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Jobb módja a swingnek | Des Moines, Iowa`)
};

/**
* | output |
* | --- |
* | "Mark Egly Golf \| A Better Way To Swing \| Des Moines, Iowa" |
*
* @param {Home_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_meta_title = /** @type {((inputs?: Home_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_meta_title(inputs)
	if (locale === "de") return de_home_meta_title(inputs)
	if (locale === "zh") return zh_home_meta_title(inputs)
	if (locale === "ar") return ar_home_meta_title(inputs)
	if (locale === "fr") return fr_home_meta_title(inputs)
	if (locale === "vi") return vi_home_meta_title(inputs)
	if (locale === "sw") return sw_home_meta_title(inputs)
	if (locale === "th") return th_home_meta_title(inputs)
	if (locale === "bs") return bs_home_meta_title(inputs)
	if (locale === "ja") return ja_home_meta_title(inputs)
	if (locale === "ko") return ko_home_meta_title(inputs)
	if (locale === "pt") return pt_home_meta_title(inputs)
	if (locale === "it") return it_home_meta_title(inputs)
	if (locale === "sv") return sv_home_meta_title(inputs)
	if (locale === "nl") return nl_home_meta_title(inputs)
	if (locale === "da") return da_home_meta_title(inputs)
	if (locale === "nb") return nb_home_meta_title(inputs)
	if (locale === "fi") return fi_home_meta_title(inputs)
	if (locale === "pl") return pl_home_meta_title(inputs)
	if (locale === "ru") return ru_home_meta_title(inputs)
	if (locale === "tr") return tr_home_meta_title(inputs)
	if (locale === "hi") return hi_home_meta_title(inputs)
	if (locale === "id") return id_home_meta_title(inputs)
	if (locale === "ms") return ms_home_meta_title(inputs)
	if (locale === "cs") return cs_home_meta_title(inputs)
	if (locale === "el") return el_home_meta_title(inputs)
	if (locale === "he") return he_home_meta_title(inputs)
	if (locale === "af") return af_home_meta_title(inputs)
	if (locale === "hu") return hu_home_meta_title(inputs)
	return en_home_meta_title(inputs)
});